const colors = {
  lightGray: "#eceded",
  gray: "#808687",
  darkGray: "#464646",
  white: "#fefefe",
  lightBlue: "#BBE1FA",
  blue: "#3282B8",
  darkBlue: "#0F4C75",
};

export default colors;
